<template>
  <!-- 工况图 workingConditionChart-->
  <div class="workingConditionChart">
    <div class="con">
      <div class="tree-left">
        <div style="margin-bottom: 5px;">
          <el-input size="medium" placeholder="输入关键字进行过滤" v-model="filterText"> </el-input>
        </div>
        <el-scrollbar style="height:calc(100% - 55px);width: 100%;">
          <el-tree class="filter-tree" :data="dataList" default-expand-all :default-expanded-keys="defaultExpanded"
            :expand-on-click-node="true" node-key="no" :props="defaultProps" :highlight-current='true'
            :filter-node-method="filterNode" ref="tree" @node-click="nodeClick">
            <template #default="{ node }">
              <span class="custom-tree-node">
                <img src="../../../public/static/image/elTree/1.9.png" v-if="node.data.type == 'AppClassType'">
                <img src="../../../public/static/image/elTree/2.4.png" v-else>
                <span style="margin-left:4px">{{ node.label }}</span>
              </span>
            </template>
          </el-tree>
        </el-scrollbar>
      </div>
      <div class="right-table">
        <img src="../../../public/static/image/elTree/gk1.png" alt="" v-show="tabNo == 2">
        <img src="../../../public/static/image/elTree/gk2.png" alt="" v-show="tabNo == 3">
        <img src="../../../public/static/image/elTree/gk3.png" alt="" v-show="tabNo == 4">
      </div>
    </div>

  </div>
</template>

<script>
  export default {

    data () {
      return {
        filterText: "",
        dataList: [
          {
            label: getName(),
            no: "0",
            type: "AppClassType",
            children: [
              {
                label: "设备-1#站点",
                no: "1",
                type: "AppClassType",
                children: [
                  {
                    label: "A站",
                    no: "2",
                    type: "dan",
                  },
                  {
                    label: "B站",
                    no: "3",
                    type: "dan",
                  },
                  {
                    label: "C站",
                    no: "4",
                    type: "dan",
                  },
                ]
              }
            ]
          }
        ],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        defaultExpanded: [],
        defaultDevice: "",
        tabNo: 2
      };
    },

    mounted () {
      this.defaultExpanded=[2]
      this.defaultDevice=2
      //默认选中
      this.$refs['tree'].setCurrentKey(this.defaultDevice);
    },
    watch: {
      filterText (val) {
        this.$refs.tree.filter(val);
      },
    },

    methods: {
      // 树形筛选
      filterNode (value,data) {
        if(!value) return true;
        return data.name.indexOf(value)!==-1;
      },
      nodeClick (val) {
        if(val.type=='dan') {
          this.tabNo=val.no
        }
      }
    },
  };
</script>

<style lang="scss" scoped>
  .workingConditionChart {

    .con {
      width: 100%;
      height: 100%;
      display: flex;
    }

    .tree-left {
      width: 300px;
      height: 100%;
      padding: 12px;
      box-sizing: border-box;
      background-color: #fff;
      margin-right: 8px;

      .item {
        padding: 4px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 120px;
        border: 2px solid #e6e6e6;
        margin-bottom: 12px;

        &.active {
          border-color: #368ED9;
        }

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .right-table {
      width: calc(100% - 3.08rem);
      height: 100%;
      padding: 8px;
      box-sizing: border-box;
      background-color: #fff;
      position: relative;

      img {
        width: 100%;
        height: 100%;
      }
    }

  }
</style>